import { Button, IconButton, TextField } from '@material-ui/core';
import { DragIndicator } from '@material-ui/icons';
import CancelIcon from '@material-ui/icons/Cancel';
import EditIcon from '@material-ui/icons/Edit';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import React, { useEffect, useReducer, useState } from 'react';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import CustomTextField from '../../shared/form-controls/custom-text-field/Custom-Text-Field';
import { formDataValidate } from '../../utils/formUtils';
import { notificationManager } from '../../utils/NotificationUtils';

const AddEditLanguages = (props) => {
  const { languages, toggleDrawer, addEditChange, showLoader = () => {} } = props;
  const [addedLanguages, setAddedLanguages] = useState([]);
  const [isEditLanguage, setIsEditLanguage] = useState({
    status: false,
    languageNdx: -1,
  });
  const [formData, setFormData] = useReducer((state, newState) => ({ ...state, ...newState }), {
    code: {
      value: '',
      fieldName: 'Language Code',
      errors: {},
      validations: ['required'],
    },
    name: {
      value: '',
      fieldName: 'Language Name',
      errors: {},
      validations: ['required'],
    },
  });
  const grid = 8;

  useEffect(() => {
    if (languages?.length) {
      let tempLanguages = [];
      let count = 0;
      languages.forEach((element) => {
        tempLanguages.push({
          code: element.code,
          name: element.name,
          index: count,
          isEdit: false,
        });
        count++;
      });
      setAddedLanguages(tempLanguages);
    }
  }, [languages]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
      const infoArray = [...addedLanguages];
      const isFound = infoArray.some((item) => {
        return (
          item.name.toLowerCase() === formData.name.value.toLowerCase() &&
          item.code.toLowerCase() === formData.code.value.toLowerCase()
        );
      });
      if (isFound) return notificationManager('danger', 'Language already exists');
      const info = {
        index:
          isEditLanguage.status && isEditLanguage.languageNdx > -1
            ? isEditLanguage.languageNdx
            : infoArray.length + 1,
        code: formData.code.value,
        name: formData.name.value,
      };
      if (isEditLanguage.status && isEditLanguage.languageNdx > -1)
        infoArray[isEditLanguage.languageNdx] = info;
      else infoArray.push(info);
      setAddedLanguages(infoArray);
      let name = { ...formData.name };
      name.value = '';
      let code = { ...formData.code };
      code.value = '';
      setFormData({ code: code, name: name });
      setIsEditLanguage({ status: false, languageNdx: -1 });
    }
  };

  const validate = () => {
    const updatedFields = {};
    const isValid = formDataValidate(formData, updatedFields);
    setFormData(updatedFields);
    return isValid;
  };

  const onCancel = () => {
    toggleDrawer(false);
  };

  const getItemStyle = (isDragging, draggableStyle) => ({
    userSelect: 'none',
    padding: 6,
    margin: `0 0 ${grid}px 0`,
    color: '#828282',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    background: '#FBFBFB',
    border: isDragging ? '2px solid #03E67C' : '2px solid #FBFBFB',
    ...draggableStyle,
  });

  const getListStyle = (isDraggingOver) => ({
    background: isDraggingOver ? '#CFF8E0' : '#FFF',
    padding: grid,
    width: '100%',
  });

  const onDragEnd = (result) => {
    // dropped outside the list
    if (!result.destination) {
      return;
    }

    const items = reorder(addedLanguages, result.source.index, result.destination.index);

    setAddedLanguages(items);
  };

  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  };

  const onLanguageDelete = (index) => {
    const currField = [...addedLanguages];

    currField.splice(index, 1);
    setAddedLanguages(currField);
  };

  const onSave = () => {
    addEditChange(addedLanguages);
    toggleDrawer(false);
  };

  const onEditSelect = (index) => {
    let tempLanguages = [...addedLanguages];
    const previousEditNdx = tempLanguages.findIndex((lang) => lang.isEdit === true);
    if (previousEditNdx > -1) tempLanguages[previousEditNdx].isEdit = false;
    const currField = { ...formData };
    tempLanguages[index].isEdit = !tempLanguages[index].isEdit;
    if (tempLanguages[index].isEdit) {
      currField.code.value = tempLanguages[index].code;
      currField.name.value = tempLanguages[index].name;
    } else {
      currField.code.value = '';
      currField.name.value = '';
    }
    setAddedLanguages(tempLanguages);
    setFormData(currField);
    setIsEditLanguage({
      status: tempLanguages[index].isEdit,
      languageNdx: tempLanguages[index].isEdit ? index : -1,
    });
  };

  const onInlineEdit = (index, type, value) => {
    let tempLanguages = [...addedLanguages];
    tempLanguages[index][type] = value.target.value;
    setAddedLanguages(tempLanguages);
  };

  return (
    <form onSubmit={handleSubmit} className='group-create' noValidate>
      <div className='container pt-4 d-flex align-items-end flex-column '>
        <div className='row px-3 w-100 mt-4'>
          <div className='col-md-6'>
            <span className='page-title'>
              {languages?.length ? 'Edit Languages' : 'Add Languages'}
            </span>
          </div>
          <div className='col-md-6 d-flex justify-content-end'>
            <IconButton aria-label='delete' onClick={(e) => onCancel(e)}>
              <CancelIcon />
            </IconButton>
          </div>
        </div>
        <div className='row px-3 w-100 d-flex mt-4'>
          <div className='row'>
            <div className='col-md-6 mb-3'>
              <CustomTextField
                item={formData.name}
                handleInputChange={(e) => {
                  setFormData({ name: e });
                }}
              />
            </div>
            <div className='col-md-6 mb-3'>
              <CustomTextField
                item={formData.code}
                handleInputChange={(e) => {
                  setFormData({ code: e });
                }}
              />
            </div>
          </div>
          <div className='row'>
            <div className='col-md-12 mb-3'>
              <Button
                variant='outlined'
                color={formData.code.value && formData.name.value ? 'primary' : 'secondary'}
                disabled={!formData.code.value || !formData.name.value}
                type='submit'
              >
                Add
              </Button>
            </div>
          </div>
          <div className='row'>
            <div className='col-md-12 mb-3 drag-item'>
              <DragDropContext onDragEnd={(e) => onDragEnd(e)}>
                <Droppable droppableId='droppable'>
                  {(provided, snapshot) => (
                    <div
                      {...provided.droppableProps}
                      ref={provided.innerRef}
                      style={getListStyle(snapshot.isDraggingOver)}
                    >
                      {addedLanguages.map((item, index) => (
                        <Draggable key={index} draggableId={'' + item.index} index={index}>
                          {(provided, snapshot) => (
                            <div
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                              style={getItemStyle(
                                snapshot.isDragging,
                                provided.draggableProps.style,
                              )}
                              className='additional-info-list-item'
                            >
                              <DragIndicator className='additional-info-drag col-2' />
                              <div className=' col-md-5'>
                                <TextField
                                  id='additional-info-field-edit'
                                  value={item.name}
                                  InputProps={{
                                    readOnly: !item.isEdit,
                                  }}
                                  onChange={(e) => onInlineEdit(index, 'name', e)}
                                />
                              </div>
                              <div className=' col-md-5'>
                                <TextField
                                  id='additional-info-value-edit'
                                  value={item.code}
                                  InputProps={{
                                    readOnly: !item.isEdit,
                                  }}
                                  onChange={(e) => onInlineEdit(index, 'code', e)}
                                />
                              </div>
                              <IconButton aria-label='edit' onClick={(e) => onEditSelect(index)}>
                                <EditIcon
                                  fontSize='small'
                                  className='icon'
                                  color={item.isEdit ? 'primary' : ''}
                                />
                              </IconButton>
                              <IconButton
                                aria-label='delete'
                                onClick={(e) => onLanguageDelete(index)}
                              >
                                <RemoveCircleIcon fontSize='small' className='icon' />
                              </IconButton>
                            </div>
                          )}
                        </Draggable>
                      ))}
                      {provided.placeholder}
                    </div>
                  )}
                </Droppable>
              </DragDropContext>
            </div>
          </div>
        </div>
        <div className='row mx-2 mt-auto px-4 w-100 pb-5'>
          <div className='col-md-12 d-flex justify-content-start'>
            <Button
              variant='contained'
              type='button'
              color='primary'
              className='me-3'
              size='large'
              onClick={(e) => {
                onSave();
              }}
            >
              Save
            </Button>
            <Button
              variant='outlined'
              type='button'
              color='secondary'
              size='large'
              onClick={(e) => onCancel(e)}
            >
              Cancel
            </Button>
          </div>
        </div>
      </div>
    </form>
  );
};

export default AddEditLanguages;
